import { useState } from 'react';

import { Date } from '../../Form/Inputs/Date.js';
import { Phone } from '../../Form/Inputs/Phone.js'
import { Text } from '../../Form/Inputs/Text.js';
import { Email } from '../Inputs/Email.js';
import { Password } from '../Inputs/Password.js';
import { Hidden } from '../../Form/Inputs/Hidden.js';

export const User = (props) => {
    const { el } = props;
    const [email, setEmail] = useState(el ? el.email : '');
    const [password, setPassword] = useState(el ? el.password : '');
    const [phone, setPhone] = useState(el ? el.mobile : '');
    return (
        <>
            <Text name="firstname" value={el ? el.firstname.toLowerCase() : ''} />
            <Text name="lastname" value={el ? el.lastname.toUpperCase() : ''} />
            <Email email={email} setEmail={setEmail} />
            <Phone name="mobile" phone={phone} setPhone={setPhone} />
            <Password password={password} setPassword={setPassword} />
            <Date name="born" value={el ? el.born : ''} />
            <Date name="date_start" value={el ? el.date_start : ''} />
            <Date name="date_end" value={el ? el.date_end : ''} />
            <Date name="date_current" value={el ? el.date_current : ''} />
            <Text name="address" value={el ? el.address : ''} />
            <Text name="zipcode" value={el ? el.zipcode : ''} />
            <Text name="city" value={el ? el.city : ''} />
            <Text name="country" value={el ? el.country : ''} />
            <Hidden name="id" value={el ? el.id : ''} />
        </>
    )
}